'use strict';

var ServicesFilterByClassFactory = function ServicesFilterByClassFactory(DataFilter) {
  function ServicesFilterByClass() {
    DataFilter.call(this, 'contributing-services-mode', 'fbcs-grid', 1);
  }
  ServicesFilterByClass.prototype = Object.create(DataFilter.prototype);
  ServicesFilterByClass.prototype.filter = function (data, range) {
    range = range[0];
    var classes = range.classes;
    return DataFilter.prototype.filter(data, classes, 'className');
  };
  return ServicesFilterByClass;
};
ServicesFilterByClassFactory.$inject = ['DataFilterFactory'];
module.exports = ServicesFilterByClassFactory;